import type { SocialNetwork } from '../types/content';

export const navLinks = [
  { label: 'Readings', to: '/readings', numeral: 'I' },
  { label: 'Shop', to: '/shop', numeral: 'II' },
  { label: 'Journal', to: '/journal', numeral: 'III' },
  { label: 'About', to: '/about', numeral: 'IV' },
  { label: 'Contact', to: '/contact', numeral: 'V' },
];

// [NEED FROM ABBY: Facebook and TikTok profile URLs]
export const socialLinks: { network: SocialNetwork; label: string; handle: string; href: string }[] = [
  { network: 'instagram', label: 'Instagram', handle: '@truetwelve', href: 'https://instagram.com/truetwelve' },
  { network: 'facebook', label: 'Facebook', handle: 'True Twelve', href: 'https://facebook.com' },
  { network: 'tiktok', label: 'TikTok', handle: '@truetwelve', href: 'https://tiktok.com' },
];

export const legalLinks = [
  { label: 'Privacy', to: '/legal/privacy' },
  { label: 'Terms', to: '/legal/terms' },
  { label: 'Shipping & Returns', to: '/legal/shipping-returns' },
  { label: 'Disclaimer', to: '/legal/disclaimer' },
];

export const disclaimer =
  'Readings and content are for insight and personal growth; not a substitute for medical, legal or financial advice.';
